import { Theme } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps, useParams, withRouter } from 'react-router-dom';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { GenericButton } from '../../components/GenericButton/GenericButton';
import { Header } from '../../components/Header/Header';
import { ROUTE_HOME } from '../../lib/constants';
import { useUniversalTracking } from '../../lib/tracking/universalTracking';
import { newContract } from '../../redux/actions/contract';
import {
	AppState,
	CollectedSelection,
	CollectedState,
	SalesType,
} from '../../types/redux';
import { isInEnum, toEnum } from '../../utils/enum';

interface Props extends
	StateProps,
	DispatchProps, RouteComponentProps {
	onSubmit(data: any): void;
}

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		minHeight: '80vh',
	},
	insuranceImage: {
		width: '100%',
		maxWidth: 180,
		display: 'flex',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	title: {
		marginBottom: theme.spacing(3),
	},
	paragraph2: {
		marginBottom: theme.spacing(5),
	},
}));

const getProductName = (type: SalesType) => {
	switch (type) {
		case SalesType.KPP:
		default:
			return 'Kaufpreis&shy;versicherung';
	}
};

const InternalThankYou: FunctionComponent<Props> = (props) => {
	const { trackEvent, trackPageView } = useUniversalTracking();
	const { t } = useTranslation();
	const classes = useStyles();
	const { salesType } = useParams<{ salesType: SalesType }>();
	const isValidSalesType = isInEnum(SalesType, salesType);
	const salesTypes = toEnum(SalesType, salesType) || SalesType.UNDEFINED;
	if (!isValidSalesType) {
		console.error('Error: unknown contract type', salesType);
	}

	const signType = props.collectedState.status === CollectedSelection.FINISH_BY_MAIL_LATER
			? 'signLater'
			: 'signed';

	useEffect(
		() => {
			// todo: page views could be handled by router
			trackPageView(props.location.pathname);
		},
		// eslint-disable-next-line
		[props.location.pathname]
	);

	const onSubmit = () => {
		props.newContract();
		trackEvent({
			category: 'thankyou-submit',
			action: 'click-event',
			label: 'thankyou',
		});
		props.history.push(`/${ROUTE_HOME}`);
	};
	let isNotEp = !salesTypes.includes(SalesType.EPK) && !salesTypes.includes(SalesType.EPH);

	return (
		<>
			<Header />
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				className={`thank_you_main ${classes.root}`}
			>
				<Grid item xs={10} sm={6}>
					<Typography variant="h1" className={classes.title}>
						<span
							dangerouslySetInnerHTML={{
								__html: t(`thank_you.${signType}.title`, {
									product: getProductName(salesTypes as SalesType),
								}),
							}}
						/>
					</Typography>
					{isNotEp && <Typography variant="body1" color="textSecondary" className={classes.paragraph2} >
						<span dangerouslySetInnerHTML={{
								__html: t(`thank_you.${signType}.paragraph2`),
							}}
						/>
					</Typography> }
					<GenericButton onClick={onSubmit}>
						{t(`thank_you.${signType}.button`)}
					</GenericButton>
				</Grid>
			</Grid>
		</>
	);
};

interface StateProps {
	collectedState: CollectedState;
}

interface DispatchProps {
	newContract(): void;
}

const mapStateToProps = (state: AppState) => ({
	collectedState: state.collectedState
});

/* istanbul ignore next */
const mapDispatchToProps = (
	dispatch: ThunkDispatch<Promise<any>, void, Action>
) => ({
	newContract: () => {
		dispatch(newContract(''));
	},
});

const withRouterComp = withRouter(InternalThankYou);
export const ThankYou = connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouterComp);
